import axios from './axiosInterceptor';
import {
    set_search_judgments_cache,
    set_crimes_cache,get_crimes_cache,
    get_search_judgments_cache,
    
} from './module/auth.js';

export const get_activities_user = (pag) =>{
    return axios.get(`/user/profile/activities/${pag}`);
}

export const verifyCode = (code,email) =>{
    return axios.post("/auth/register/verify",{ code : code, email : email });
}

export const userRegister = (data)=> {

    return axios.post("/auth/register",data);
}

export const get_verify_code = (email) =>{
    return  axios.get(`/auth/verificationCode/${email}`)
}

export const on_login = (data) => axios.post(`/auth/login`,data);

export const loader_search_judgments = () => {

    const search_judgments_cache = get_search_judgments_cache();

    // if(search_sentences_cache !== null){
    //     return new Promise((resolve)=>{
    //         return resolve(search_sentences_cache);
    //     });
    // }

    return new Promise((resolve,reject)=> {
        axios.get(`/judgmentsResolveds/search`).then((result) => {
            
            set_search_judgments_cache(result);

            resolve(result)

        }).catch(err => reject(err))
    });
}

export const get_crimes = (matter)=>{

    const cache = get_crimes_cache(matter);

    if(cache !== null){
        return new Promise((resolve)=>{
            return resolve(cache);
        });
    }

    return new Promise((resolve,reject)=> {
        axios.get(`/catalog/crimes/byMatter/${matter}`).then((result) => {
            
            set_crimes_cache(matter,result);
            resolve(result)

        }).catch(err => reject(err))
    });
}


export const get_search_judgments = (search) =>{

    return axios.post(`/judgmentsResolveds/search`,search);

}

export const get_departments = (district) =>{
    return axios.get(`/auth/departments/${district}`);
}

export const get_municipalities = (department) =>{
    return axios.get(`/municipalities/${department}`);

}

export const get_publications = (type,pag = 0) =>{
    // const cache = get_publications_cache(type,pag);  
    // if(cache !== null){
        return new Promise((resolve,reject)=>{

            axios.get(`/publicationsDigital/${type}/${pag}`)
            .then((result) => {
                return resolve(result);
            })
            .catch((error) => { reject(error)})
        });
    // }
}

export const get_publications_types = () =>{
    return axios.get("/publicationsDigital/types");
}

export const get_tree_history_sentence = () =>{
    return axios.get("/historyOfJudgmentResolved/tree");

}

export const get_document_history_sentence = (id) =>{
    return axios.get(`/historyOfJudgmentResolved/${id}/document`);
}

export const getDataProfile = ()=>{
    return axios.get("/user/getProfile");
}


// export const get_criterias = (matter) =>{
//     return axios.get(`/api/auth/criterias/${matter}`);
// }

